import { getURI } from './uri';
function getSrcset(fittingType, src, target, options, data) {
    const dpr = target.pixelAspectRatio || 1;
    return {
        dpr: [
            `${dpr === 1
                ? data.uri
                : getURI(fittingType, src, Object.assign(Object.assign({}, target), { pixelAspectRatio: 1 }), options)} 1x`,
            `${dpr === 2
                ? data.uri
                : getURI(fittingType, src, Object.assign(Object.assign({}, target), { pixelAspectRatio: 2 }), options)} 2x`,
        ],
    };
}
export { getSrcset };
//# sourceMappingURL=srcset.js.map